import { Component, OnInit } from '@angular/core';
import { VisitorsService } from 'src/app/shared/service/visitors.service';

@Component({
  selector: 'app-categories-report',
  templateUrl: './categories-report.component.html',
  styleUrls: ['./categories-report.component.scss']
})
export class CategoriesReportComponent {

  public categoriesList: { CategoryID: number, AR_Name: string, Views: number }[] = []

  constructor(
    visitorService: VisitorsService,
  ) {
    visitorService.getCategoriesReport().subscribe(response => {
      this.categoriesList = response;
    });
  }


  public settings = {
    pager: {
      perPage: 50,
    },

    actions: {
      add: false,
      edit: false,
      delete: false,
      position: 'right'
    },
    columns: {
      // CategoryID: {
      //   title: 'ID',
      //   width: '50px',
      //   filter: false,
      // },
      AR_Name: {
        title: 'اسم القسم'
      },
      Views: {
        title: 'اجمالي المشاهدات',
        width: '250px',
      },
    },
  };
}